import React from "react";

type HorizontalLineProps = {
    borderColor: string;
}

export function HorizontalLine(props: HorizontalLineProps) {
    // #03A9F4

    return <hr style={{borderColor: props.borderColor, borderBottom: 'none'}}/>

}